var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useNavigate } from "react-router-dom";
import { useCompleteStep as useCompleteStepAPI } from "../../../../utils/responseComplete";
import { updateStepByPath } from "ah_utility/workflow";
import { insertIntoStepInformation } from "../../../../utils/upsertStepInformation";
import { updateStepInLocalStorage } from "../../../../utils/updateStapeCustom";
export var useCompleteStepPlanDetail = function (_a) {
    var workFlowId = _a.workFlowId, instanceId = _a.instanceId, currentStep = _a.currentStep, nextStep = _a.nextStep, pathname = _a.pathname, nextRoute = _a.nextRoute, setSeeToast = _a.setSeeToast;
    var navigate = useNavigate();
    var _b = useCompleteStepAPI(), runComplete = _b.runComplete, loadingComplete = _b.loadingComplete, errorComplete = _b.errorComplete;
    var onClickNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, prevStep, currentStep_1, nextStep_1, sessionData, err_1;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, runComplete({
                            workFlowId: workFlowId,
                            instanceId: instanceId,
                            currentStep: currentStep,
                            nextStep: nextStep,
                        })];
                case 1:
                    res = _f.sent();
                    if (res) {
                        updateStepByPath(pathname);
                        prevStep = (_a = res.upcomingFormStep) === null || _a === void 0 ? void 0 : _a.prevSteps[0];
                        currentStep_1 = (_b = res.upcomingFormStep) === null || _b === void 0 ? void 0 : _b.id;
                        nextStep_1 = (_c = res.upcomingFormStep) === null || _c === void 0 ? void 0 : _c.nextSteps[0];
                        insertIntoStepInformation({
                            stepKey: pathname,
                            data: {
                                currentStep: currentStep_1,
                                nextStep: nextStep_1,
                                prevStep: prevStep,
                            },
                        });
                        sessionData = ((_d = res.sessionData) === null || _d === void 0 ? void 0 : _d.apiResponses) || [];
                        if (sessionData.length > 0) {
                            updateStepInLocalStorage(pathname, sessionData);
                        }
                        navigate(nextRoute);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _f.sent();
                    setSeeToast({
                        show: true,
                        message: (_e = err_1 === null || err_1 === void 0 ? void 0 : err_1.message) !== null && _e !== void 0 ? _e : "Ocurrió un error al completar el paso.",
                        type: typeAlert.error,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        onClickNext: onClickNext,
        loadingComplete: loadingComplete,
        errorComplete: errorComplete,
    };
};
